import { fromStorage, setStorage } from '@/utils/storage';
import forEach from 'lodash/forEach';

function saveQueryParams({ params }) {
    forEach(params, (value, key) => {
        setStorage(key, value);
    });
}

function setQueryParams(router, params) {
    // Try to load params from storage
    const _params = {};
    forEach(params, param => {
        const valueFromStorage = fromStorage(param);
        if (valueFromStorage) {
            _params[param] = valueFromStorage;
        }
    });

    // Try to load params from URL
    router.beforeResolve((to, from, next) => {
        let paramsFound = false;
        forEach(params, param => {
            const valueFromUrl = to.query[param];
            if (valueFromUrl) {
                paramsFound = true;
                _params[param] = valueFromUrl;

                // Remove param from URL
                to.query[param] = undefined;
            }
        });

        saveQueryParams({ params: _params });

        if (paramsFound) {
            router.replace(to);
        } else {
            next();
        }
    });
}

export { setQueryParams };
